// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--7-1!../../../node_modules/postcss-loader/lib/index.js??ref--7-2!./iconfont.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("634b0783", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.css
// module id = muQq
// module chunks = 46